export default /*@ngInject*/ function ($rootScope) {
    const vm = this;

    vm.$onInit = init;

    async function init() {
        vm.hybridConnectionsArray = vm.hybridConnectionsArray;
        vm.helpObject = $rootScope.helpObject;
    }
}